import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=0bd4df6c&"
import script from "./Contract.vue?vue&type=script&lang=js&"
export * from "./Contract.vue?vue&type=script&lang=js&"
import style0 from "./Contract.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports